import { useEffect, useState } from "react";
import api from "@/lib/api";

// Settings change rarely; share one fetch across pages and refresh after saving.
let cache = null;
let inflight = null;
const listeners = new Set();

export function loadSettings(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!inflight || force) {
    inflight = api.get("/settings").then((r) => {
      cache = r.data;
      inflight = null;
      listeners.forEach((fn) => fn(cache));
      return cache;
    }).catch((e) => { inflight = null; throw e; });
  }
  return inflight;
}

export function setSettingsCache(s) {
  cache = s;
  listeners.forEach((fn) => fn(cache));
}

export function useSettings() {
  const [s, setS] = useState(cache);
  useEffect(() => {
    listeners.add(setS);
    loadSettings().then(setS).catch(() => {});
    return () => listeners.delete(setS);
  }, []);
  return s;
}
